import React, { useState, useEffect } from 'react';
import config from 'react-global-configuration';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';

const CartProductImage = ({ image }) => {
  const [url, setUrl] = useState(null);
  const language = useSelector((state) => state.getIn(['ui', 'language']));

  useEffect(() => {
    const loadImage = async () => {
      if (image) {
        const id = image.getIn(['data', 'id']);
        if (id) {
          const API_URL = config.get('API_URL');
          const MULTILINGUAL = config.get('MULTILINGUAL', true);
          const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;
          const imageData = await fetch(`${PATH}/jsonapi/file/file/${id}`);
          const imageDataJson = Immutable.fromJS(await imageData.json());
          setUrl(`${API_URL}${imageDataJson.getIn(['data', 'attributes', 'uri', 'url'])}`);
        }
      }
    };

    loadImage();
  }, [image, language]);

  if (!url) {
    return null;
  }

  return (
    <Image src={url} alt="" />
  );
};

export default CartProductImage;
